import { Box, Card, Button } from '@mui/material';
import LayoutAccessManagement from 'components/structure/LayoutAccessManagement';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Delegation from "assets/delegation.svg";
import UserFunctionalityService from 'services/UserFunctionalityService';
import { SnackbarContext } from 'context/snackBarContext';
import { AuthData } from "auth/AuthWarpper";
import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EditIcon from "assets/EditIcon.svg";
import RoleService from 'services/RoleService';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#0A3575",
        color: theme.palette.common.white,
        height: "52px",
        fontSize: "16px",
        fontWeight: 600,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: "16px",
        height: "100px",
        color: "#191E31",
        fontWeight: 600,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: "#ffffff",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const RoleAssignList = () => {
    const navigate = useNavigate();
    const { user } = AuthData();
    const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);
    const [data, setdata] = useState([]);
    const [fetched, setFetched] = useState(false);




    const columns = [
        { label: "Role Name", field: "role_name", align: "left" },
        { label: "Assigned Functionality", field: "roleFunctionality", align: "left", width: "400px" },
        { label: "Status", field: "status", align: "left" },
        { label: "Action", field: "action", align: "left" },
    ];
    // const data = [
    //     { roleFunctionality: 'roleFunctionality', roleName: 'Role Name', isActive: 'true' },
    //     { roleFunctionality: 'roleFunctionality', roleName: 'Role Name', isActive: 'true' },
    //     { roleFunctionality: 'roleFunctionality', roleName: 'Role Name', isActive: 'true' },
    //     { roleFunctionality: 'roleFunctionality', roleName: 'Role Name', isActive: 'true' },
    // ];


    const CallListAPI = async () => {
        try {
            let id = user?.userId
            UserFunctionalityService.FetchUserFunctionalityList(id).then((res) => {
                setdata(res?.data?.response)
                setFetched(true)
            }).catch((error) => {
                setSeverity("error");
                setMessage(error?.response?.data?.message || error?.message);
                setOpenAlert(true);
                setdata([])
                setFetched(true)
                console.log(error)
            })
        } catch (error) {
            setSeverity("error");
            setMessage(error?.response?.data?.message || error?.message);
            setOpenAlert(true);
            setFetched(true)
        }
    }

    if (user && !fetched) {
        CallListAPI()
    }


    const getStatusColor = (status) => {
        switch (status) {
            case 'Complete':
                return '#50AF47';
            case 'Pending':
                return '#EF7D00';
            default:
                return 'black';
        }
    };
    
    return (
        <LayoutAccessManagement title="Access Management">
            <Card
                className='Access-Management-Layout'
                sx={{
                    backgroundColor: "#f3f5f8",
                    color: "white",
                    marginBottom: "30px",
                    padding: "30px",
                    border: "none",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                    <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '20px' }}>
                        <Button
                            // variant="outlined"
                            sx={{
                                pt: '6px',
                                pr: '15px',
                                pb: '6px',
                                pl: '15px',
                                background: '#ffffff',
                                boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                                color: "#0A3575",
                                fontWeight: 500,
                                borderRadius: "11px",
                                border: '0.739px solid #FFF',
                                color: '#0A3575',
                                fontSize: '20.696px',
                                fontFamily: 'Montserrat',
                                textTransform: 'capitalize',
                                fontWeight: '500',
                                display: "flex",
                                maxWidth: "187px",

                            }}
                            startIcon={<img src={Delegation} alt="delegation" />}
                            onClick={() => navigate('/selfDelegationList', { state: { fromUrl: "RoleAssignList" } })}
                        >
                            Delegation
                        </Button>
                    </Box>
                    <Box sx={{ width: "100%", marginTop: "40px", marginBottom: "40px", borderRadius: '16px', backgroundColor: "#fff", height: "auto" }}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        {columns?.map((column, index) => (
                                            <StyledTableCell key={index} align={column.align || "left"}>
                                                {column.label}
                                            </StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.map((row, rowIndex) => (
                                        <StyledTableRow key={rowIndex}>
                                            {columns?.map((column, colIndex) => (
                                                <StyledTableCell
                                                    key={colIndex}
                                                    align={column.align || "left"}
                                                    width={column.width || ""}
                                                >
                                                    {column.field === "action" ? (
                                                        <img
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() =>
                                                                navigate(`${'/RoleEdit'}`, { state: { rowData: row, fromUrl: "/RoleAssignList" } })
                                                            }
                                                            src={EditIcon}
                                                            alt="Edit"
                                                        />
                                                    ) : (
                                                        <>
                                                            {column.field === "roleFunctionality" ? (
                                                                <div>
                                                                    {row?.functionalities?.map((ele) => ele?.functionality_name).join(', ')}

                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {column.field === "status" ? (
                                                                        <div style={{ color: getStatusColor(row[column.field]) }}>
                                                                            {row[column.field]}

                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {row[column.field]}
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box>

                        </Box>
                    </Box>
                </Box>

            </Card>
        </LayoutAccessManagement >
    );
}

export default RoleAssignList;
